import { v4 as uuidv4 } from 'uuid';
import getBrowserCookieId from './getBrowserCookieId';
import getCarvanaUserId from './getCarvanaUserId';
import correlationId from './correlationId';
import getCurrentRoute from './getCurrentRoute';
import getReferralUrl from './getReferralUrl';
import getBrowserResolution from './getBrowserResolution';
import getScreenResolution from './getScreenResolution';
import getUserAgent from './getUserAgent';

const getEnvelope = async (
  environment,
  project,
  track,
  eventName,
  correlationIdOverride,
  url?: string,
) => {
  const carvanaUserId = await getCarvanaUserId();
  return {
    clickstream: {
      ...(carvanaUserId && {
        carvanaUser: { id: carvanaUserId },
      }),
      browser: {
        cookieId: await getBrowserCookieId(),
        resolution: await getBrowserResolution(),
        referralUrl: await getReferralUrl(),
        url: url ?? (await getCurrentRoute()),
        userAgent: await getUserAgent(),
      },
      device: {
        resolution: await getScreenResolution(),
      },
    },
    event: {
      id: uuidv4(),
      name: eventName,
      timestamp: new Date(),
    },
    metadata: {
      correlationId: correlationIdOverride || correlationId,
      environment,
      project,
      track,
    },
  };
};

export default getEnvelope;
